import React, { useState, useEffect } from 'react';
import { Pagination, Select } from '@arco-design/web-react';
import { getAnalysisProgressApi } from '../../Api/api';

export default function TableSummary({ 
  total, 
  pageSize, 
  current, 
  setCurrent, 
  setPageSize,
  taskId,
  progressData = {
    progressCurrent: 0,
    total: 0,
    intentYesCount: 0,
    intentPercent: 0,
    progressPercent: 0,
    intentPercent: 0
  }
}) {
  const [apiProgressData, setApiProgressData] = useState({
    ic_num: 0,
    num: 0,
    sum: 0,
    state: 0
  });

  // 获取进度数据
  useEffect(() => {
    if (!taskId) {
      // 重置进度数据
      setApiProgressData({
        ic_num: 0,
        num: 0,
        sum: 0,
        state: 0
      });
      return;
    }
    
    let interval = null;
    
    const fetchProgressData = async () => {
      try {
        const response = await getAnalysisProgressApi(taskId);
        
        if (response && response.status === 200 && response.data) {
          const newData = {
            ic_num: response.data.ic_num || 0,
            num: response.data.num || 0,
            sum: response.data.sum || 0,
            state: response.data.state || 0
          };
          setApiProgressData(newData);
          
          // 如果分析完成，清除轮询
          if (newData.state === 3 || newData.num >= newData.sum) {
            if (interval) {
              clearInterval(interval);
              interval = null;
            }
          }
          
          return newData;
        }
      } catch (error) {
        console.error('获取进度数据失败:', error);
      }
      return null;
    };
    
    // 立即获取一次数据
    fetchProgressData().then((data) => {
      if (data && data.state !== 3 && data.num < data.sum && data.sum > 0) {
        // 只有在分析进行中时才启动轮询
        interval = setInterval(fetchProgressData, 30000);
      }
    });
    
    // 清理函数
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [taskId]); // 只依赖taskId

  // 计算进度百分比
  const progressPercent = apiProgressData.sum > 0 ? Math.round((apiProgressData.num / apiProgressData.sum) * 100) : 0;
  const intentPercent = apiProgressData.num > 0 ? Math.round((apiProgressData.ic_num / apiProgressData.num) * 100) : 0;
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 30 }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
      <span style={{ marginRight: 10, color: '#666', fontSize: 14 }}>
        进度：{apiProgressData.num} / {apiProgressData.sum}
      </span>
      <div style={{
        width: 200,
        height: 8,
        background: '#f0f0f0',
        borderRadius: 4,
        marginRight: 8,
        overflow: 'hidden'
      }}>
        <div style={{
          width: `${progressPercent}%`,
          height: '100%',
          background: '#1890ff',
          borderRadius: 4,
          transition: 'width 0.3s ease'
        }}></div>
      </div>
      <span style={{ color: '#666', fontSize: 14 }}>
        {progressPercent}%
      </span>
      <span style={{ marginLeft: 16, color: '#666', fontSize: 14 }}>
        意向：{apiProgressData.ic_num} 个，占比：{intentPercent}%
      </span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', marginRight: 3}}>
        <Pagination
          total={total}
          pageSize={pageSize}
          current={current}
          onChange={setCurrent}
          showTotal
          showJumper
          showPageSizeChanger
          pageSizeOptions={[5, 10, 20]}
          onPageSizeChange={setPageSize}
        />
        <Select
          style={{ width: 120, marginLeft: 16 }}
          value={pageSize}
          onChange={setPageSize}
          options={[5, 10, 20].map(v => ({ label: `${v} 条/页`, value: v }))}
        />
      </div>
    </div>
  );
}